import { render } from "./allBeds.vue?vue&type=template&id=84f54fa8&scoped=true"
import script from "./allBeds.vue?vue&type=script&lang=js"
export * from "./allBeds.vue?vue&type=script&lang=js"

import "./allBeds.vue?vue&type=style&index=0&id=84f54fa8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f54fa8"]])

export default __exports__